import deepFreeze from 'deep-freeze-strict';
import { collectionConstructorFactory } from "../collection/collectionConstructorFactory";
import { authRequestApiTemplate } from "./apis/auth";
export const authTemplate = deepFreeze({
  templateId: 'auth',
  name: '单接口',
  desc: '第三方鉴权接口',
  apiTemplates: [authRequestApiTemplate]
});
export const AuthCollection = collectionConstructorFactory(authTemplate);
//# sourceMappingURL=Auth.js.map
